/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocks_Movers_Top_Losers_TitleInputs */

const en_stocks_movers_top_losers_title = /** @type {(inputs: Stocks_Movers_Top_Losers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today’s Top Losers`)
};

const de_stocks_movers_top_losers_title = /** @type {(inputs: Stocks_Movers_Top_Losers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größte Verlierer heute`)
};

const pt_br2_stocks_movers_top_losers_title = /** @type {(inputs: Stocks_Movers_Top_Losers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maiores quedas de hoje`)
};

const tr_stocks_movers_top_losers_title = /** @type {(inputs: Stocks_Movers_Top_Losers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bugünün en çok düşenleri`)
};

const zh_cn2_stocks_movers_top_losers_title = /** @type {(inputs: Stocks_Movers_Top_Losers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今日跌幅榜`)
};

const zh_hk2_stocks_movers_top_losers_title = /** @type {(inputs: Stocks_Movers_Top_Losers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今日跌幅榜`)
};

const ko_kr2_stocks_movers_top_losers_title = /** @type {(inputs: Stocks_Movers_Top_Losers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오늘의 하락률 상위`)
};

const ru_ru2_stocks_movers_top_losers_title = /** @type {(inputs: Stocks_Movers_Top_Losers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лидеры падения за сегодня`)
};

const es_419_stocks_movers_top_losers_title = /** @type {(inputs: Stocks_Movers_Top_Losers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mayores bajas de hoy`)
};

/**
* | output |
* | --- |
* | "Today’s Top Losers" |
*
* @param {Stocks_Movers_Top_Losers_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const stocks_movers_top_losers_title = /** @type {((inputs?: Stocks_Movers_Top_Losers_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocks_Movers_Top_Losers_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stocks_movers_top_losers_title(inputs)
	if (locale === "de") return de_stocks_movers_top_losers_title(inputs)
	if (locale === "pt-BR") return pt_br2_stocks_movers_top_losers_title(inputs)
	if (locale === "tr") return tr_stocks_movers_top_losers_title(inputs)
	if (locale === "zh-CN") return zh_cn2_stocks_movers_top_losers_title(inputs)
	if (locale === "zh-HK") return zh_hk2_stocks_movers_top_losers_title(inputs)
	if (locale === "ko-KR") return ko_kr2_stocks_movers_top_losers_title(inputs)
	if (locale === "ru-RU") return ru_ru2_stocks_movers_top_losers_title(inputs)
	return es_419_stocks_movers_top_losers_title(inputs)
});